import React from "react";

const PaymentOptionModal = ({ isOpen, onClose, onTerminalClick, onUrlClick }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="relative bg-white p-6 rounded-lg w-full max-w-sm">
                {/* Close Button */}
                <button
                    onClick={onClose}
                    className="absolute top-2 right-2 text-black text-xl font-bold hover:text-red-500"
                >
                    &times;
                </button>

                <h2 className="text-xl text-black mb-4 text-center">Choose Payment Method</h2>

                <div className="flex justify-center space-x-4">
                    <button
                        onClick={onTerminalClick}
                        className="px-4 py-2 bg-[#2C594C] text-white rounded hover:bg-[#244e43]"
                    >
                        Terminal
                    </button>
                    <button
                        onClick={onUrlClick}
                        className="px-4 py-2 bg-[#4f598c] text-white rounded hover:bg-[#434b7c]"
                    >
                        Checkout URL
                    </button>
                </div>
            </div>
        </div>
    );
};

export default PaymentOptionModal;
